import styled from 'styled-components';

export const ItemVideoWrapper = styled.div`
  width: 100%;
  height: 328px;
`;
